import { Container } from "@fideus-ui/core";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod/v4";
import { AnnualStatementDetailPage } from "../../../companies/annualStatements/AnnualStatementDetailPage";
import { AnnualStatementsTab } from "../../../companies/annualStatements/AnnualStatementsTab";

const searchSchema = z.object({
  jahr: z.coerce.number().int().optional(),
});

export const Route = createFileRoute("/firmen/$companyId/jahresabschluesse")({
  validateSearch: zodValidator(searchSchema),
  loader: async ({ context: { queryClient, trpc }, params: { companyId } }) => {
    void queryClient.ensureQueryData(
      trpc.annualStatements.listAnnualStatementsByCompanyId.queryOptions({
        companyId,
      })
    );
    void queryClient.ensureQueryData(trpc.getHubspotPortalId.queryOptions());
  },
  component: JahresabschluesseRoute,
});

function JahresabschluesseRoute() {
  const { companyId } = Route.useParams();
  const { jahr } = Route.useSearch();

  if (jahr) {
    return (
      <Container>
        <AnnualStatementDetailPage companyId={companyId} year={jahr} />
      </Container>
    );
  }

  return (
    <Container>
      <AnnualStatementsTab companyId={companyId} />
    </Container>
  );
}
